var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"tile":""}},[_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.message)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }